import requester from '@/lib/axios';
import { VideoActivityElement } from '@/models/_deprecated/ActivityElement';

const baseUrl = 'video-activity';
const nestedUrl = (activityId: number) => `activities/${activityId}/${baseUrl}`;

export const getVideoActivity = async (id: number) => {
  const { data: video } = await requester().get<VideoActivityElement>(
    `${baseUrl}/${id}/`,
  );
  return video;
};

export const createVideoQuestionIntoActivity = async (
  activityId: number,
  body: Partial<VideoActivityElement>,
) => {
  const { data } = await requester().post<VideoActivityElement>(
    `${nestedUrl(activityId)}/`,
    body,
  );
  return data;
};

export const updateVideoQuestionIntoActivity = async (
  activityId: number,
  id: number,
  changes: Partial<Omit<VideoActivityElement, 'id'>>,
) => {
  const { data } = await requester().patch<VideoActivityElement>(
    `${nestedUrl(activityId)}/${id}/`,
    changes,
  );
  return data;
};

export const deleteVideoQuestionIntoActivity = async (
  activityId: number,
  id: number,
) => {
  await requester().delete(`${nestedUrl(activityId)}/${id}/`);
};
